module.exports = __webpack_public_path__ + "static/img/BB.de666e6b.png";